export default {
  // 导航
  "nav.home": "首页",
  "nav.category": "分类浏览",
  "nav.about": "关于我们",
  "nav.latest": "最新入口",

  // 通用
  "common.readMore": "阅读全文",
  "common.viewAll": "查看全部",
  "common.backToTop": "回到顶部",
  "common.search": "搜索",
  "common.loading": "加载中...",
  "common.noData": "暂无数据",
  "common.breadcrumb.home": "首页",

  // Footer
  "footer.copyright": "草榴二维码指南",
  "footer.rights": "版权所有",
  "footer.disclaimer": "本站仅提供二维码入口信息指引，不存储任何内容。请用户遵守当地法律法规，合理使用网络资源。",
  "footer.quickLinks": "快速链接",
  "footer.categories": "内容分类",
  "footer.contact": "联系我们",
  "footer.followUs": "关注我们",
}